import '../scss/app.scss';

const $ = jQuery;

let wpadminoffset = 0;
if ($('#wpadminbar').outerHeight() > 0) {
    wpadminoffset = $('#wpadminbar').outerHeight();
}
let navHeight = 85;
let sticked = false;
const nav = $('header.navigation');
const top = nav.length > 0 ? nav.offset().top : null;

// Featured Slider
$(document).ready(function() {
	$('.quotes-slider').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: true,
		autoplay: true,
        autoplaySpeed: 5000,
        pauseOnHover: false,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
    });

    $('iframe[src*="youtube"],iframe[src*="youtu.be"],iframe[src*="vimeo"]').parent().fitVids();
});

// Galleries
$(document).ready(function() {
    $('.text-gallery-images-wrapper').each(function() {
        $(this).find('a').featherlightGallery({
            previousIcon: '<i class="fal fa-angle-left"></i>',
            nextIcon: '<i class="fal fa-angle-right"></i>',
        });
    });
	$('.gallery-wrapper').each(function() {
        $(this).find('.gallery-images-wrapper').featherlightGallery({
            targetAttr: 'data-target',
            previousIcon: '<i class="fal fa-angle-left"></i>',
            nextIcon: '<i class="fal fa-angle-right"></i>',
        });
    });
});

// Contact form modal
$(document).ready(function() {
    $('a.contact-button').attr('href', '#get-mysterious');
    $('a.contact-button, .contact-button a').featherlight({ targetAtr: 'href', variant: 'contact', persist: 'shared' });
    if (window.location.hash === '#get-mysterious') {
        setTimeout(function() {
            $('.contact-button a').click();
        }, 1000);
    }
});

// Experience modal
$(document).ready(function() {
    $('.experience-modal-open').click(function() {
        console.log('cliek');
    })
    $('a.experience-modal-open').featherlight({ targetAtr: 'href', variant: '' });
});

function updateStickyNav() {
    if (nav.length === 0) {
        return;
    }

    if (window.scrollY > 20) {
        if (!sticked) {
            nav.addClass('sticky');
            sticked = true;
        }
    } else if (sticked) {
        nav.removeClass('sticky');
        sticked = false;
    }

    let activeLink = null;
    $('.navigation-menu li').each(function(index, link) {
        if (!$(link).hasClass('contact-button') && $(link).find('a').attr('href').indexOf('#') === 0) {
            const section = $($(link).find('a').attr('href'));
            $(link).removeClass('active');
            if (section && section.length > 0 && section.offset().top <= window.scrollY + wpadminoffset + nav.outerHeight() + 5) {
                activeLink = $(link);
            }
        }
    });
    if (activeLink) {
        activeLink.addClass('active');
    }
}

function resizeVideoModals() {
    $('.modal-video').css('width', Math.min(1000, $(window).width() - 100));
}

$(window).scroll(function() {
    updateStickyNav();
});

$(window).resize(function() {
    resizeVideoModals();
});

$(document).ready(function() {
    updateStickyNav();
    resizeVideoModals();

    const hash = window.location.hash;
    window.location.hash = '';
    if (hash.indexOf('#') === 0) {
        if ($(hash).length > 0) {
            setTimeout(function() {
                window.scrollTo({
                    top: $(hash).offset().top - navHeight - wpadminoffset,
                    behavior: 'smooth',
                });
            });
        }
    }

    $('.navigation-menu a, .mobile-menu a').click(function(e) {
        if ($(this).attr('href').indexOf('#') === 0 && !$(this).parent().hasClass('contact-button')) {
            if ($('body').hasClass('content-page')) {
                e.preventDefault();
                window.location = '/' + $(this).attr('href');
            }
            if ($($(this).attr('href')).length > 0) {
                e.preventDefault();
                window.scrollTo({
                    top: $($(this).attr('href')).offset().top - navHeight - wpadminoffset,
                    behavior: 'smooth',
                });
                $('.sliding-panel-content, .sliding-panel-fade-screen').removeClass('is-visible');
            }
        }
    });
});

// Sliding panel
$(document).ready(function() {
    $('.sliding-panel-button, .sliding-panel-fade-screen, .sliding-panel-close').on('click touchstart', function(e) {
        $('.sliding-panel-content, .sliding-panel-fade-screen').toggleClass('is-visible');
        e.preventDefault();
    });
});



// WEBPACK FOOTER //
// ./src/js/app.js